import { createRoot } from 'react-dom/client';
import { captureException } from '@sentry/browser';

import { ProductSpecificationList } from './components/ProductSpecificationList';
import '../shared/utils/i18n';
import { ProductProperty } from './components/ProductSpecification';

const selector = '#product-specifications-list';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector(selector);

  const specificationsContainer = document.querySelector('script#product-specifications-content');
  const extraSpecsContainer = document.querySelector('script#product-extra-specs-content');

  const specifications = JSON.parse(specificationsContainer?.textContent || '[]').filter(
    (v: ProductProperty) => !!v.ValueID || !!v.Value
  );

  const extraSpecs = JSON.parse(extraSpecsContainer?.textContent || '[]').filter(
    (v: ProductProperty) => !!v.ValueID || !!v.Value
  );

  if (container) {
    const root = createRoot(container);

    root.render(<ProductSpecificationList specifications={[...specifications, ...extraSpecs]} />);
  } else {
    captureException(new Error(`Could not find ${selector}`));
  }
});
